import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import {
  apiAuthenticate,
  apiPostChangePassword,
} from "../shared/manager/api_manager";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { getValueByQueryString } from "../shared/manager/util";
import { useLingueStore } from "../sistema/storeLingua";
import "./login.css";

export default function PasswordRecoverScreen() {
  const { selectedLinguaTesto } = useLingueStore(
    (state) => state
  );
  const navigate = useNavigate();

  const [password2Status, setPassword2Status] = useState("");
  const [passwordStatus, setPasswordStatus] = useState("");

  const password2Input = React.useRef();
  const passwordInput = React.useRef();

  const [recoverPwdDialogOpen, setRecoverPwdDialogOpen] = useState(false);

  function handleSubmit() {
    console.log("handleSubmit");

    if (validateForm()) {
      const uniqueId = getValueByQueryString("ID");
      const password = passwordInput.current.value;

      const authData = {
        uniqueId: uniqueId,
        newPassword: password,
      };

      apiPostChangePassword(authData, apiAuthCallback);
    }
  }

  function validateForm() {
    console.log("validateForm");
    let valid = true;
    const password2 = password2Input.current.value;
    const password = passwordInput.current.value;
    if (password2 == null || password2 == "") {
      valid = false;
      setPassword2Status(" notvalid");
    } else {
      setPassword2Status("");
    }

    if (password == null || password == "") {
      valid = false;
      setPasswordStatus(" notvalid");
    } else {
      setPasswordStatus("");
    }

    if (valid) {
      if (password != password2) {
        setPassword2Status(" notvalid");
        setPasswordStatus(" notvalid");
        valid = false;
      }
    }

    return valid;
  }

  function apiAuthCallback(response) {
    console.log(response);
    if (response != null && response.status >= 200 && response.status < 400) {
      setRecoverPwdDialogOpen(true);
    } else {
      console.error("apiAuthCallback");
    }
  }

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      handleSubmit();
    }
  }

  const handleDialogClose = () => {
    setRecoverPwdDialogOpen(false);
    navigate("/login");
  };

  return (
    <div id="avp-login-screen">
      <div id="avp-login-screen-content">
        <div id="avp-login-screen-body-header">
          <div id="avp-login-screen-body-header-title">
            {selectedLinguaTesto?.PasswordRecoverTitle}
          </div>
          <div id="avp-login-screen-body-header-subtitle">
            {selectedLinguaTesto?.PasswordRecoverSubtitle}
          </div>
        </div>
        <div className="avp-login-form-container">
          <div className="avp-login-form">
            <div className="avp-login-form-title">
              {selectedLinguaTesto?.PasswordRecoverFormTitle}
            </div>

            <div className="avp-login-form-content">
              <div className="avp-login-elemento">
                <label className="avp-login-label" htmlFor="avp-login-password">
                  {selectedLinguaTesto?.PasswordRecoverFormPassword}
                </label>
                <input
                  className={"avp-login-input" + passwordStatus}
                  type="password"
                  id="avp-login-password"
                  ref={passwordInput}
                />
              </div>

              <div className="avp-login-elemento">
                <label
                  className="avp-login-label"
                  htmlFor="avp-login-password2"
                >
                  {selectedLinguaTesto?.PasswordRecoverFormRepeatPassword}
                </label>
                <input
                  className={"avp-login-input" + password2Status}
                  type="password"
                  id="avp-login-password2"
                  ref={password2Input}
                  onKeyDown={handleKeyDown}
                />
              </div>

              <div id="avp-login-errore" className="avp-login-elemento"></div>

              <div className="avp-login-elemento">
                <button
                  className="avp-login-button"
                  onClick={() => handleSubmit()}
                >
                  {selectedLinguaTesto?.PasswordRecoverFormButtonConfirm}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={recoverPwdDialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Recupero password"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selectedLinguaTesto?.PasswordRecoverDialog}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} autoFocus>
            {selectedLinguaTesto?.PasswordRecoverDialogConfirm}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
